import {
  ADD_ERROR_ALERT,
  REMOVE_ERROR_ALERT,
  ADD_SUCCESS_ALERT,
  REMOVE_SUCCESS_ALERT,
  ADD_MESSAGE_ALERT,
  REMOVE_MESSAGE_ALERT,
  ADD_WARNING_ALERT,
  REMOVE_WARNING_ALERT
} from "../actions/types";

const INITIAL_STATE = {
  errorAlerts: [],
  successAlerts: [],
  messageAlerts: [],
  warningAlerts: []
};

 // eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_ERROR_ALERT:
      return {
        ...state,
        errorAlerts: [
          ...state.errorAlerts,
          { ...action.payload, id: state.errorAlerts.length }
        ]
      };
    case REMOVE_ERROR_ALERT:
      state.errorAlerts.splice(action.payload);
      return {
        ...state,
        errorAlerts: [...state.errorAlerts]
      };
    case ADD_SUCCESS_ALERT:
      return {
        ...state,
        successAlerts: [
          ...state.successAlerts,
          action.payload
        ]
      };
    case REMOVE_SUCCESS_ALERT:
      state.successAlerts.splice(action.payload);
      return {
        ...state,
        successAlerts: [...state.successAlerts]
      };
    case ADD_MESSAGE_ALERT:
      return {
        ...state,
        messageAlerts: [
          ...state.messageAlerts,
          { ...action.payload, id: state.messageAlerts.length }
        ]
      };
    case REMOVE_MESSAGE_ALERT:
      state.messageAlerts[action.payload].expired = true;
      return {
        ...state,
        messageAlerts: [...state.messageAlerts]
      };
    case ADD_WARNING_ALERT:
      return {
        ...state,
        warningAlerts: [
          ...state.warningAlerts,
          { ...action.payload, id: state.warningAlerts.length }
        ]
      };
    case REMOVE_WARNING_ALERT:
      state.warningAlerts[action.payload].expired = true;
      return {
        ...state,
        warningAlerts: [...state.warningAlerts]
      };
    default:
      return state;
  }
};
